module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_papua_new_guinea-63ac11cb.png";